import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import type { OnboardingFeatureKey } from '@gokrew/models/company';
import { useAuth } from '@/context/AuthContext';
import { useModuleEnabled } from '@/hooks/useModuleEnabled';

interface ModuleGuardProps {
  module: OnboardingFeatureKey;
  children: ReactNode;
}

/**
 * Renders a module's route only while the company has that module switched
 * on, and sends anyone who reaches it by URL back to the dashboard otherwise.
 * Hiding the sidebar entry alone would leave the page one bookmark away.
 */
export function ModuleGuard({ module, children }: ModuleGuardProps) {
  const { isFeatureFlagsLoading } = useAuth();
  const isModuleOn = useModuleEnabled();

  if (isFeatureFlagsLoading) return null;
  if (!isModuleOn(module)) return <Navigate to="/dashboard" replace />;
  return children;
}
